import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomersContext } from "../../contexts/customers/customers.context";

const CustTicketPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { customer } = state || {};
  const { handleChange } = useContext(CustomersContext);

  // State to hold customer data
  const [customerData, setCustomerData] = useState({
    business_name: "",
    purchase_order_email: [],
    daily_invoices: false,
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [emails, setEmails] = useState([]);

  // Update customerData when customer is available
  useEffect(() => {
    if (customer) {
      setCustomerData(customer);
      if (customer.purchase_order_email) {
        setEmails(customer.purchase_order_email.map((entry) => entry.email));
      }
    }
  }, [customer]);

  // Add Email Handler
  const handleAddEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(emailInput)) {
      alert("Please enter a valid email address.");
      return;
    }

    if (emails.includes(emailInput)) {
      alert("This email is already in the list.");
      return;
    }

    const updatedEmails = [...emails, emailInput];

    setEmails(updatedEmails);
    setCustomerData((prev) => ({
      ...prev,
      purchase_order_email: updatedEmails.map((email) => ({ email })),
    }));

    setEmailInput("");
    setIsModalOpen(false);
  };

  // Remove Email Handler
  const handleRemoveEmail = (email) => {
    const updatedEmails = emails.filter((e) => e !== email);

    setEmails(updatedEmails);
    setCustomerData((prev) => ({
      ...prev,
      purchase_order_email: updatedEmails.map((email) => ({ email })),
    }));
  };

  return (
    <div className="p-6 flex flex-col gap-6 items-center bg-gray-100 min-h-screen">
      {/* Title */}
      <h1 className="text-2xl font-bold text-gray-800">{customer?.business_name}</h1>

      {/* Main Content */}
      <div className="flex justify-center items-start gap-8 w-full max-w-6xl">
        {/* Emails Section */}
        <div className="bg-white shadow-md rounded-lg w-1/3 p-4">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Emails</h2>
            <button
              className="bg-green-500 text-white px-3 py-1 rounded-md hover:bg-green-600"
              onClick={() => setIsModalOpen(true)}
            >
              Add +
            </button>
          </div>
          <div className="h-32 border rounded-md p-2 bg-gray-50 overflow-y-auto">
            {emails.map((email, index) => (
              <div
                key={index}
                className="flex justify-between items-center bg-gray-100 px-3 py-1 mb-2 rounded-md shadow-sm"
              >
                <span>{email}</span>
                <button
                  className="text-red-500 hover:text-red-700"
                  onClick={() => handleRemoveEmail(email)}
                >
                  X
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Open Tickets Section */}
        <div className="bg-white shadow-md rounded-lg w-1/4 p-4 flex flex-col items-center">
          <h2 className="text-lg font-semibold">Open Tickets</h2>
          <p className="text-3xl font-bold mt-4">0</p>
          {/* Create Statement Button */}
        </div>

        {/* Custom Fields Section */}
        <div className="bg-white shadow-md rounded-lg w-1/3 p-4">
          <h2 className="text-lg font-semibold mb-4">Custom Fields</h2>
          <div className="mb-4">
            <label className="block text-gray-600 mb-2">Send Daily Invoices</label>
            <select
              className="border w-full rounded-md p-2 bg-gray-50"
              value={customerData?.daily_invoices ? "Yes" : "No"}
              onChange={(e) => 
                setCustomerData((prev) => ({
                  ...prev,
                  daily_invoices: e.target.value === "Yes",
                }))
              }
            >
              <option>No</option>
              <option>Yes</option>
            </select>
          </div>
          <button
            onClick={() => handleChange(customerData)}
            className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
          >
            Update
          </button>
        </div>
      </div>
      <div className="bg-white shadow-md rounded-lg w-1/4 p-4 flex flex-col items-center">
        
        <button
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            onClick={() => navigate("/manualstatement", { state: { customer } })}
          >
            Create Statement
          </button>
      </div>
      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center">
          <div className="bg-white rounded-lg p-6 shadow-lg w-1/3">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Add Email</h2>
              <button
                className="text-gray-500 hover:text-gray-700"
                onClick={() => setIsModalOpen(false)}
              >
                X
              </button>
            </div>
            <input
              type="email"
              className="border w-full rounded-md p-2 mb-4"
              placeholder="Email"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
            />
            <button
              className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
              onClick={handleAddEmail}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustTicketPage;
